import ActionModal from 'components/common/ActionModal/ActionModal';

export const DeleteDraftStudyModal = ({
    isOpen, 
    onClose,
    deleteDraftStudy,
    goToNextLocation,
    ...props
}) => {

    const handleOnSave = () => {
        const { institutionId, study: { originalFields: { studyId } } } = props;
        deleteDraftStudy(institutionId, studyId);
        onClose(false);
        goToNextLocation();
    };

    return <ActionModal
        isOpen={isOpen}
        onClose={onClose}
        onSave={handleOnSave}
        title='Delete Draft'
    >
        <DeleteModalHelperText />
    </ActionModal>;
};

const DeleteModalHelperText = () => 'This will delete the draft study. Do you want to proceed?';
